/**
 * Does Word accept a text edit at all right now?
 *
 * Asked only after a tool's write has already failed with `GeneralException`, which is
 * what Word says for a document still waiting on Edit Anyway -- and also for plenty of
 * other things, so the code alone cannot tell "this edit was bad" from "no edit can
 * work". A second, trivially valid edit can: a zero-width space inserted at the start
 * of the body and deleted in the same batch. If Word refuses that, it is refusing the
 * document rather than the edit. (A-42 in docs/assumptions.md.)
 *
 * It has to be text. A hidden bookmark was tried first and Word accepted it in exactly
 * this state while refusing every text edit, so the probe passed and the model went
 * on retrying. Deleting your own insertion leaves no revision even with Track Changes
 * on, and a failed insert queues nothing after it, so the probe cannot leave a mark.
 *
 * Never asked before an edit: `document.mode` cannot be trusted in this state (A-41),
 * and a probe on every write would be a round trip for nothing in the common case.
 */

const ZERO_WIDTH_SPACE = "​";

export async function wordAcceptsWrites(): Promise<boolean> {
  try {
    await Word.run(async (context) => {
      const inserted = context.document.body
        .getRange("Start")
        .insertText(ZERO_WIDTH_SPACE, "Before");
      inserted.delete();
      await context.sync();
    });
    return true;
  } catch (error) {
    // Kept in the console so a report of "the message did not appear" can be checked
    // against what Word actually said to the probe.
    console.warn("[Jylo] write probe refused", error);
    return false;
  }
}
